// extracted by mini-css-extract-plugin
module.exports = {"text":"UgcS2","text-red":"_3w9IT","wrapper":"_1lfXN","headline":"_3gnzu","details":"_1_wfq","paragraph":"_2ALOS","close-icon":"_1_cS-","address":"_3ol35","note":"_36lL8"};